import { h } from 'preact';
import {CreditCards} from '../../index';
import style from './tinyFooter.module.css';
import {logoGoogleSafe} from '../.././../assets'
import { useAppContext } from '../../../contexts';
import {useMediaQuery} from "../../../hooks";

const TinyFooter = () => {
    const {highContrast} = useAppContext();

    const matches = useMediaQuery('(max-width: 768px)');

    // URL parameters
    const urlParams = new URLSearchParams(window.location.search);
    // Searches for the "onboarding" querystring at the path url
    const onboardingLayout = urlParams.get('onboarding');
    // This is used to hide the second and the third header rows at the onboarding page
    const isOnboardingPage =
        window.location.pathname === "/entre" &&
        onboardingLayout &&
        !matches;

    if (isOnboardingPage) {
        return null;
    }

    return (
        <div className={`container-fluid hidden md:block h-[7rem] lg:h-[4.5rem] border-t ${style.customBorder} ${highContrast ? "grayBackground" : "bg-light-gray"}`}>
            <div className='sabin-container mx-auto flex flex-col lg:flex-row-reverse lg:justify-between lg:items-center h-full'>
                <div className='pt-[0.5rem] pb-[1rem]'>
                    <CreditCards styles="w-7 lg:w-10" />
                </div>
                <div className='hidden lg:block'>
                    <a
                        href="https://transparencyreport.google.com/safe-browsing/search?url=https:%2F%2Floja.sabin.com.br"
                        data-testid="tiny-footer-link"
                    >
                        <img
                            src={logoGoogleSafe}
                            className={`${style.logoGoogleSafe} ${highContrast ? "whiteImage" : ""}`}
                            width="180"
                            alt="Google safe browsing"
                            data-testid="tiny-footer-image"
                        />
                    </a>
                </div>
                <div className={`flex flex-col ${highContrast ? "highLabelFourth" : ""}`}>
                    <span className='hidden lg:block text-sm' data-testid="tiny-footer-email">
                        E-mail: lojavirtual@sabin.com.br
                    </span>
                    <span className="lg:hidden text-sm" data-testid="tiny-footer-fone">
                        Fale conosco: (61) 3329-8000
                    </span>
                    <span className="text-xs mt-[0.5rem]" data-testid="tiny-footer-cnpj">
                        Sabin Medicina Diagnóstica - CNPJ - 00.718.528/0001-09
                    </span>
                </div>
            </div>
        </div>
    )
};

export default TinyFooter;
